import styled from "styled-components";
import { FlexContainer, FlexDiv, FlexSection } from "@/components/Atoms";
import StyledSvgSprite from "@/components/Atoms/SVGSprite";
import Typography from "@/foundation/Typography/V2";

export const Container = styled(FlexContainer)`
  flex-direction: column;
  @media only screen and (max-width: 992px) {
    padding: 0;
  }
`;
export const Wrapper = styled(FlexSection)`
  flex-direction: column;
  background-color: ${({ theme }) => theme.colorsV2.shyft.cream};
  padding: 40px 0;
  @media only screen and (max-width: 992px) {
    padding: 0;
  }
`;
export const HeroBox = styled(FlexDiv)`
  margin-top: 40px;
  align-items: center;
  @media only screen and (max-width: 992px) {
    margin-top: 0;
    padding: 40px 24px;
    position: relative;
    > * {
      position: relative;
      z-index: 2;
    }
    &:before {
      content: "";
      position: absolute;
      top: 0;
      z-index: 0;
      left: 0px;
      width: 100%;
      height: 100%;
      ${({ backImage }) =>
        backImage &&
        `
          background: url(${backImage}) center no-repeat;
          background-size: cover;
      `}
      background-color: ${({ theme }) => theme.colorsV2.gray.shade_500};
    }
    &:after {
      content: "";
      position: absolute;
      height: 100%;
      width: 100%;
      bottom: 0;
      left: 0;
      z-index: 1;
      pointer-events: none;
      background: linear-gradient(
        180deg,
        rgba(${({ theme }) => theme.colors.shadows.black}, 0) 30%,
        rgba(${({ theme }) => theme.colors.shadows.black}, 0.6) 78.39%
      );
    }
  }
`;
export const RatingBox = styled(FlexDiv)`
  flex-direction: column;
  @media only screen and (max-width: 399px) {
    margin-bottom: 24px;
  }
`;
export const BottomBox = styled(FlexDiv)`
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 24px;
  @media only screen and (max-width: 399px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
export const DetailBox = styled(FlexDiv)`
  width: 100%;
`;
export const LHSBox = styled(FlexDiv)`
  padding: 8px 64px 8px 16px;
  align-items: flex-start;
  justify-content: center;
  flex: 1;
  flex-direction: column;
  margin-right: 16px;
  @media only screen and (max-width: 992px) {
    margin-right: 0;
    width: 100%;
    padding: 0;
    justify-content: flex-end;
    min-height: 308px;
  }
`;
export const RHSBox = styled(FlexDiv)`
  position: relative;
  max-width: 57.9%;
  max-height: 360px;
  width: 100%;
  height: 360px;
  border-radius: 8px;
  box-shadow: 0 12px 36px 0
    rgba(${({ theme }) => theme.colors.shadows.purple_2}, 0.2);
  overflow: hidden;
  img {
    height: 100%;
    width: 100%;
    max-height: 100%;
    object-fit: cover;
  }
  @media only screen and (max-width: 1169px) {
    max-width: 50%;
  }
`;
export const Badge = styled(Typography)`
  color: ${({ theme }) => theme.colorsV2.primary.shade_800};
  padding: 8px 16px;
  border-radius: 32px;
  background-color: ${({ theme }) => theme.colors.white};
  margin-bottom: 8px;
  @media only screen and (max-width: 992px) {
    display: none;
  }
`;
export const RecipeTitle = styled(Typography)`
  text-transform: capitalize;
  color: ${({ theme }) => theme.colorsV2.blueGray.shade_800};
  margin-bottom: 8px;
  @media only screen and (max-width: 992px) {
    color: ${({ theme }) => theme.colors.white};
  }
`;
export const Subtitle = styled(Typography)`
  color: ${({ theme }) => theme.colorsV2.gray.shade_800};
  margin-bottom: 24px;
  @media only screen and (max-width: 992px) {
    color: ${({ theme }) => theme.colors.white};
    margin-bottom: 0;
  }
`;
export const RatingText = styled(Typography)`
  color: ${({ theme }) => theme.colors.black};
  margin-bottom: 4px;
`;
export const AboutRating = styled(Typography)`
  color: ${({ theme }) => theme.colors.black};
  padding: 0 8px;
  max-width: 180px;
  @media only screen and (max-width: 399px) {
    max-width: 100%;
    padding: 0;
  }
`;
export const Tags = styled(Typography)`
  align-items: center;
  display: flex;
  color: ${({ theme }) => theme.colorsV2.gray.shade_700};
  padding: 8px 16px;
  margin-right: 8px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 24px;
  &:last-child {
    margin-right: 0;
  }
  @media only screen and (max-width: 992px) {
    background-color: ${({ theme }) => theme.colorsV2.shyft.cream};
  }
`;
export const Strong = styled.strong``;
export const RatingCount = styled(Typography)`
  margin-left: 8px;
  color: ${({ theme }) => theme.colorsV2.gray.shade_800};
  strong {
    font-size: inherit;
    font-family: var(--man-800);
    color: inherit;
    line-height: inherit;
  }
`;
export const StarCountBox = styled(FlexDiv)`
  align-items: center;
`;
export const TimeIcon = styled(StyledSvgSprite)`
  fill: ${({ theme }) => theme.colorsV2.gray.shade_700};
  margin-right: 8px;
`;
export const BannerText = styled(FlexDiv)`
  flex-direction: column;
`;
